module.exports = __webpack_public_path__ + "img/search_map_grey.9a70db25.svg";